import React, { useState, useEffect, useCallback } from 'react';
import { GoogleAuthProvider, signInWithPopup, onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from './firebase-config';
import './Login.css';

// Sofortiger Log außerhalb der Komponente
console.log('Login.js wird geladen');

const AUTHORIZED_EMAIL = 'hardvorevibeandi@gmail.com';

function Login({ onLoginStatusChange }) {
  // Sofortiger Log innerhalb der Komponente
  console.log('Login-Komponente wird gerendert');
  
  const [user, setUser] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Memoize die Logout-Funktion, damit sie nicht bei jedem Render neu erstellt wird
  const handleLogout = useCallback(async () => {
    console.log('Abmeldung gestartet');
    setLoading(true);
    try {
      await signOut(auth);
      console.log('Abmeldung erfolgreich');
      // Der Auth-Status wird durch den onAuthStateChanged-Listener aktualisiert
    } catch (err) {
      console.error('Fehler beim Abmelden:', err);
      setError('Abmeldefehler: ' + (err.message || 'Unbekannter Fehler'));
    } finally {
      setLoading(false);
    }
  }, []);

  // Überwache den Authentifizierungsstatus
  useEffect(() => {
    console.log('Login-Komponente initialisiert, überwache Auth-Status');
    
    // Verhindere mehrfache Listener-Registrierungen
    let isSubscribed = true;
    
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (!isSubscribed) return;
      
      console.log('Auth-Status geändert:', currentUser ? `Benutzer: ${currentUser.email}` : 'Nicht angemeldet');
      
      if (currentUser) {
        // Prüfe, ob die E-Mail autorisiert ist
        if (currentUser.email === AUTHORIZED_EMAIL) {
          console.log('Autorisierter Benutzer erkannt:', currentUser.email);
          setUser(currentUser);
          if (onLoginStatusChange) onLoginStatusChange(true);
        } else {
          // Nicht autorisierte E-Mail - abmelden
          console.log('Nicht autorisierter Benutzer:', currentUser.email);
          handleLogout();
          setError('Nur die E-Mail-Adresse hardvorevibeandi@gmail.com ist berechtigt.');
        }
      } else {
        setUser(null);
        if (onLoginStatusChange) onLoginStatusChange(false);
      }
    });

    // Cleanup-Funktion
    return () => {
      isSubscribed = false;
      unsubscribe();
    };
  }, [handleLogout]); // Nur von handleLogout abhängig, nicht von onLoginStatusChange

  const handleGoogleLogin = async () => {
    console.log('Google-Anmeldung gestartet');
    setLoading(true);
    setError('');
    try {
      console.log('Erstelle GoogleAuthProvider');
      const provider = new GoogleAuthProvider();
      
      // Konfiguriere den Provider für eine bessere Benutzererfahrung
      provider.setCustomParameters({
        prompt: 'select_account'
      });
      console.log('Provider konfiguriert, öffne Popup...');
      
      // Protokolliere Firebase-Auth-Status vor dem Popup
      console.log('Firebase Auth-Status vor Popup:', auth.currentUser ? 'Angemeldet' : 'Nicht angemeldet');
      
      // Versuche das Popup zu öffnen
      console.log('Rufe signInWithPopup auf...');
      await signInWithPopup(auth, provider);
      
      console.log('Google-Anmeldung erfolgreich abgeschlossen');
      // Der Auth-Status wird durch den onAuthStateChanged-Listener aktualisiert
    } catch (err) {
      console.error('Fehler bei der Google-Anmeldung:', err);
      console.log('Fehlercode:', err.code);
      console.log('Fehlermeldung:', err.message);
      console.log('Fehler-Details:', JSON.stringify(err, null, 2));
      setError('Anmeldefehler: ' + (err.message || 'Unbekannter Fehler'));
    } finally {
      console.log('Google-Anmeldeprozess abgeschlossen, loading auf false gesetzt');
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {user ? (
        <div className="login-user-info">
          <p>Angemeldet als: {user.email}</p>
          <button 
            onClick={handleLogout} 
            disabled={loading}
            className="login-button logout"
          >
            Abmelden
          </button>
        </div>
      ) : (
        <div className="login-form">
          <p>Bitte melde dich an, um fortzufahren.</p>
          <button 
            onClick={handleGoogleLogin} 
            disabled={loading}
            className="login-button google"
          >
            Mit Google anmelden {loading && '...'}
          </button>
          <p className="login-note">Hinweis: Nur die E-Mail-Adresse hardvorevibeandi@gmail.com ist berechtigt.</p>
        </div>
      )}
      {error && <p className="login-error">{error}</p>}
    </div>
  );
}

export default Login; 